// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e17685bd","703":"e81456f8","787":"1dba70de"}[chunkId] + ".chunk.js";
};